import type { PageThemeDefinition } from "../types";

export const roseTheme: PageThemeDefinition = {
  id: "rose",
  labelKey: "robot.setting.page_theme.rose",
  preview: {
    background: "#1A0A14",
    cardBg: "#241018",
    text: "#ffffff",
  },
  tokens: {
    background: "#1A0A14",
    cardBg: "#241018",
    text: "#ffffff",
    textSecondary: "#D4A8C0",
    border: "#4A2038",
    headerBg: "#1A0A14",
    inputBg: "#241018",
    messageBg: "#241018",
    senderBg: "#241018",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#5a3048",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#2E1420",
    accent: "#E84393",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#321424",
    chatAgentBubbleBorder: "#4A2840",
    chatUserGradientStart: "#D63384",
    chatUserGradientEnd: "#9B1B5A",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#1A0A14",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#D4A8C0",
    chatMediaBg: "#1A0A14",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#FD79A8",
  },
};
